/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/factory'
export default icon
